import { render } from "./AvisoPriv.vue?vue&type=template&id=5e71e49a"
import script from "./AvisoPriv.vue?vue&type=script&lang=js"
export * from "./AvisoPriv.vue?vue&type=script&lang=js"
script.render = render

export default script